import { ITokenDecoder } from "@/domain/repositories/DecodeToken";
import jwtDecode from "jwt-decode";

export class JwtDecode implements ITokenDecoder {
  async decode(token: string): Promise<any> {
    const decodedToken = jwtDecode(token);
    return decodedToken;
  }
}
